import React from "react";

import { Box, Button, Stack, Theme, Typography } from "@mui/material";
import __ from "src/utils/Translations";

import { getLanguage } from "src/utils/Languages/LanguageContext";

import Page404PL from "./Page404_pl.svg";
import Page404EN from "./Page404_en.svg";

export interface Page404Props {
  customBodyText?: string;
}

const Page404: React.FC<Page404Props> = ({ customBodyText }) => {
  const image = getLanguage() === "en" ? Page404EN : Page404PL;

  return (
    <Box
      sx={{
        maxWidth: "1600px",
        margin: "0 auto",
        padding: { xs: "1rem", sm: "1.5rem", lg: "2rem 3rem" },
      }}
    >
      <Box
        sx={(theme: Theme) => ({
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          [theme.breakpoints.down("lg")]: {
            flexDirection: "column",
            alignItems: "center",
          },
        })}
      >
        <Box
          sx={(theme: Theme) => ({
            order: 2,
            flex: 1,
            textAlign: "end",
            [theme.breakpoints.down("lg")]: {
              order: 1,
              textAlign: "center",
              mb: 4,
              width: "100%",
            },
          })}
        >
          <img style={{ maxWidth: "100%" }} src={image} alt={__("Błąd 404")} />
        </Box>
        <Stack
          sx={(theme: Theme) => ({
            order: 1,
            flex: 1,
            [theme.breakpoints.down("lg")]: {
              order: 2,
              alignItems: "center",
            },
          })}
        >
          <Typography
            sx={(theme: Theme) => ({
              fontSize: "60px",
              fontWeight: 800,
              lineHeight: "72px",
              mb: "16px",
              [theme.breakpoints.down("lg")]: {
                fontSize: "34px",
                lineHeight: "40px",
                textAlign: "center",
              },
            })}
          >
            404.
          </Typography>
          <Typography
            sx={(theme: Theme) => ({
              fontSize: "34px",
              lineHeight: "40px",
              fontWeight: 700,
              mb: "16px",
              [theme.breakpoints.down("lg")]: {
                fontSize: "24px",
                lineHeight: "29px",
                textAlign: "center",
              },
            })}
          >
            {__("Nie możemy znaleźć tej strony")}
          </Typography>
          <Typography
            sx={(theme: Theme) => ({
              fontSize: "16px",
              lineHeight: "24px",
              [theme.breakpoints.down("lg")]: {
                textAlign: "center",
              },
            })}
          >
            {__(
              "Strona, której szukasz, mogła zostać przeniesiona lub usunięta."
            )}
            <br />
            {customBodyText ||
              __(
                "Sprawdź, czy wpisany adres URL jest poprawny lub wróć na Stronę Główną."
              )}
          </Typography>
          <Button
            variant="contained"
            sx={(theme: Theme) => ({
              mt: "32px",
              alignSelf: "flex-start",
              [theme.breakpoints.down("lg")]: {
                alignSelf: "center",
              },
            })}
            href="/"
          >
            {__("Wróć na stronę główną")}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default Page404;
